import { I18n } from 'i18n-js';
import translations from './translations.json';

const i18n = new I18n(translations);
i18n.defaultLocale = 'fr';
i18n.locale = 'fr';

export function pluralize(labels, count) {
  return (count > 1 ? labels.other : labels.one).replace('%{count}', count);
}

export default i18n;
